(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["da-athletics"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('da-athletics')) {
  customElements.define('da-athletics', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const buttons = [...this.querySelectorAll('[data-club-filter]')];
      const designs = [...this.querySelectorAll('[data-design-club]')];
      const setClub = club => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.clubFilter === club)));
        designs.forEach(design => design.hidden = club !== 'all' && design.dataset.designClub !== club);
      };
      buttons.forEach(button => button.addEventListener('click', () => setClub(button.dataset.clubFilter)));
      this.addEventListener('shopify:block:select', () => setClub('all'));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-aussie-rules"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('da-aussie-rules')) {
  customElements.define('da-aussie-rules', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const buttons = [...this.querySelectorAll('[data-club-filter]')];
      const designs = [...this.querySelectorAll('[data-design-club]')];
      const setClub = club => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.clubFilter === club)));
        designs.forEach(design => design.hidden = club !== 'all' && design.dataset.designClub !== club);
      };
      buttons.forEach(button => button.addEventListener('click', () => setClub(button.dataset.clubFilter)));
      this.addEventListener('shopify:block:select', () => setClub('all'));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-case-study"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('da-product-carousel')) {
  customElements.define('da-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.viewport = this.querySelector('.da-carousel__viewport');
      this.track = this.querySelector('.da-carousel__track');
      this.group = this.querySelector('.da-carousel__group');
      this.toggle = this.querySelector('[data-pause]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.abort = new AbortController();
      const opts = {signal: this.abort.signal};
      this.clones = [];
      if (this.group.children.length > 1) {
        for (let n = 0; n < 2; n++) {
          const clone = this.group.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          clone.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
          this.track.append(clone);
          this.clones.push(clone);
        }
      } else this.paused = true;
      this.measure = () => {this.width = this.group.getBoundingClientRect().width; if (this.clones.length) this.viewport.scrollLeft = this.width;};
      this.resize = new ResizeObserver(this.measure);
      this.resize.observe(this.viewport);
      this.visible = true;
      this.observer = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting;});
      this.observer.observe(this);
      this.updateButton = () => {this.toggle.textContent = this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel; this.toggle.setAttribute('aria-pressed', String(this.paused));};
      this.stop = () => {this.paused = true; this.updateButton();};
      this.toggle.addEventListener('click', () => {this.paused = !this.paused; this.updateButton();}, opts);
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        this.stop();
        const step = this.group.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(this.group).gap);
        this.viewport.scrollBy({left: Number(button.dataset.step) * step, behavior: this.motion.matches ? 'instant' : 'smooth'});
      }, opts));
      this.viewport.addEventListener('pointerdown', this.stop, opts);
      this.viewport.addEventListener('wheel', this.stop, {...opts, passive:true});
      this.viewport.addEventListener('keydown', this.stop, opts);
      this.viewport.addEventListener('scroll', () => {
        if (!this.width || !this.clones.length) return;
        if (this.viewport.scrollLeft < 1) this.viewport.scrollLeft += this.width;
        else if (this.viewport.scrollLeft >= this.width * 2) this.viewport.scrollLeft -= this.width;
      }, {...opts, passive:true});
      this.addEventListener('mouseenter', () => {this.hovered = true;}, opts);
      this.addEventListener('mouseleave', () => {this.hovered = false;}, opts);
      this.addEventListener('focusin', () => {this.focused = true;}, opts);
      this.addEventListener('focusout', event => {this.focused = this.contains(event.relatedTarget);}, opts);
      this.motion.addEventListener('change', () => {if (this.motion.matches) this.stop();}, opts);
      this.updateButton();
      this.measure();
      const frame = time => {
        const delta = Math.min(time - (this.lastTime || time), 50);
        this.lastTime = time;
        if (!this.paused && !this.hovered && !this.focused && this.visible && !document.hidden && this.width) {
          this.scrollCarry = (this.scrollCarry || 0) + delta * Number(this.dataset.speed || 30) / 1000;
          const amount = Math.floor(this.scrollCarry);
          if (amount) {this.viewport.scrollLeft -= amount; this.scrollCarry -= amount;}
        }
        this.frameId = requestAnimationFrame(frame);
      };
      this.frameId = requestAnimationFrame(frame);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frameId);
      this.abort?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
      this.clones?.forEach(clone => clone.remove());
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-create-range"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('da-create-range')) {
  customElements.define('da-create-range', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const sport = this.querySelector('[data-sport]');
      if (!sport) return;
      const items = [...this.querySelectorAll('[data-item]')];
      const summary = this.querySelector('[data-summary]');
      const empty = summary.textContent;
      let requestedOuterwear = new URLSearchParams(window.location.search).get('outerwear');
      const error = this.querySelector('[data-error]');
      const updateSummary = () => {
        const chosen = items.filter(i => i.checked && !i.disabled);
        summary.textContent = chosen.length ? chosen.map(i => i.dataset.title).join(' · ') : empty;
        error.hidden = true;
      };
      const updateSport = () => {
        const key = sport.selectedOptions[0]?.dataset.key;
        this.querySelector('[data-products]').hidden = !key;
        this.querySelector('[data-details]').hidden = !key;
        const seen = new Set();
        this.querySelectorAll('[data-category]').forEach(category => {
          const active = !!key && (category.dataset.category === 'shared' || category.dataset.sportKey === key);
          category.hidden = !active;
          category.querySelectorAll('[data-item]').forEach(input => {
            const duplicate = active && seen.has(input.dataset.productId);
            if (active) seen.add(input.dataset.productId);
            input.disabled = !active || duplicate;
            input.closest('label').hidden = duplicate;
            if (input.disabled) input.checked = false;
          });
        });
        if (requestedOuterwear) {
          const matchingItem = items.find(item => !item.disabled && item.dataset.productHandle === requestedOuterwear);
          if (matchingItem) { matchingItem.checked = true; requestedOuterwear = null; }
        }
        updateSummary();
      };
      sport.addEventListener('change', updateSport);
      items.forEach(i => i.addEventListener('change', updateSummary));
      this.querySelector('[data-clear]').addEventListener('click', () => { items.forEach(i => i.checked = false); updateSummary(); });
      this.querySelector('form').addEventListener('submit', event => {
        if (!items.some(i => i.checked && !i.disabled)) {
          event.preventDefault();
          error.textContent = this.dataset.pickError;
          error.hidden = false;
          this.querySelector('[data-item]:not(:disabled)')?.focus();
        }
      });
      const requestedSport = new URLSearchParams(window.location.search).get('sport');
      if (requestedSport) {
        const matchingOption = [...sport.options].find(option => option.value.toLowerCase() === requestedSport.toLowerCase());
        if (matchingOption) sport.value = matchingOption.value;
      }
      updateSport();
      const requestedItem = new URLSearchParams(window.location.search).get('item');
      if (requestedItem) {
        const matchingItem = items.find(item => !item.disabled && item.dataset.productCode === requestedItem);
        if (matchingItem) { matchingItem.checked = true; updateSummary(); }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-cricket"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('da-cricket')) {
  customElements.define('da-cricket', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const buttons = [...this.querySelectorAll('[data-club-filter]')];
      const designs = [...this.querySelectorAll('[data-design-club]')];
      const setClub = club => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.clubFilter === club)));
        designs.forEach(design => design.hidden = club !== 'all' && design.dataset.designClub !== club);
      };
      buttons.forEach(button => button.addEventListener('click', () => setClub(button.dataset.clubFilter)));
      this.addEventListener('shopify:block:select', () => setClub('all'));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-netball"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('da-netball')) {
  customElements.define('da-netball', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const buttons = [...this.querySelectorAll('[data-club-filter]')];
      const designs = [...this.querySelectorAll('[data-design-club]')];
      const setClub = club => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.clubFilter === club)));
        designs.forEach(design => design.hidden = club !== 'all' && design.dataset.designClub !== club);
      };
      buttons.forEach(button => button.addEventListener('click', () => setClub(button.dataset.clubFilter)));
      this.addEventListener('shopify:block:select', () => setClub('all'));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-outerwear"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('da-outerwear')) {
  customElements.define('da-outerwear', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const buttons = [...this.querySelectorAll('[data-club-filter]')];
      const designs = [...this.querySelectorAll('[data-design-club]')];
      const setClub = club => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.clubFilter === club)));
        designs.forEach(design => design.hidden = club !== 'all' && design.dataset.designClub !== club);
      };
      buttons.forEach(button => button.addEventListener('click', () => setClub(button.dataset.clubFilter)));
      this.addEventListener('shopify:block:select', () => setClub('all'));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-training"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('da-training')) {
  customElements.define('da-training', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const buttons = [...this.querySelectorAll('[data-club-filter]')];
      const designs = [...this.querySelectorAll('[data-design-club]')];
      const setClub = club => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.clubFilter === club)));
        designs.forEach(design => design.hidden = club !== 'all' && design.dataset.designClub !== club);
      };
      buttons.forEach(button => button.addEventListener('click', () => setClub(button.dataset.clubFilter)));
      this.addEventListener('shopify:block:select', () => setClub('all'));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
